import React from "react";
import styles from "./notificationIcon.module.scss";
import WarningIcon from "@material-ui/icons/Warning";

export interface INotification {
  notifications: number;
}

const DynamicNotificationIcon = (props: INotification) => {
  const notifications = props.notifications;
  return (
    <div className={styles.container}>
      <WarningIcon fontSize="small" />
      {!notifications ? null : (
        <p className={styles.circle}>{notifications} </p>
      )}
    </div>
  );
};

export default DynamicNotificationIcon;
